<div class="cds-flex cds-flex-col cds-h-full">
  <!-- Header !-->
  <nav class="!cds-flex cb-header cb-header--purple cb-header--sticky !cds-z-[995]" data-testid="navbar">
    <!-- Header: Logo, Menus -->
    <div class="logo">
      <img src="/images/logos/chubb-black.svg" />
      <p class="cds-hidden sm:cds-block separator"></p>
      <p class="cds-hidden sm:cds-block text">QFA</p>
    </div>

    @if (userinfo) {
      <div class="cds-flex cds-gap-2 cds-items-center">
        <cb-icon iconKey="utility-account-stroke" iconSize="regular" iconColor="neutral-black"/>
        <p class="body-regular" data-testid="navbar-username">{{ userinfo }}</p>
      </div>
    }
  </nav>

  <!-- Application -->
  <div class="cds-w-full cds-h-full">
    <router-outlet/>
  </div>
</div>

<div>
  <cb-modal
    [open]="openErrorModal"
    (closeEvent)="hideError()"
    title="Error"
    [closeOnEscape]="false"
    customContent="true"
    [hideCloseIcon]="false"
    [hideDefaultFooter]="true"
    data-testid="global-error-modal">
    <div class="cds-flex cds-flex-col">
      <div class="cds-flex cds-items-start cds-gap-2 cds-h-full">
        <cb-icon
          iconKey="utility-error-stroke"
          [iconColor]="'error-shade'"
          [addPointerClass]="false"
          iconSize="large"/>
        <p class="body-regular cds-text-error-shade" data-testid="global-error-modal-message">
          {{ errorMessage }}
        </p>
      </div>
      <button
        cbButton
        label="Ok"
        class="cds-mt-8 cds-flex cds-w-fit cds-self-end"
        variant="primary"
        colorTheme="purple"
        data-testid="global-error-modal-ok-button"
        (click)="hideError()"></button>
    </div>
  </cb-modal>
</div>
